import { onIframeLoad } from './utils/dom'

class MediaDefer {
  element?: HTMLElement
  wasClicked = false

  constructor(element: HTMLElement) {
    this.element = element
    this.onClick = this.onClick.bind(this)
    this.element?.addEventListener('click', this.onClick)
    if (this.mediaElement instanceof HTMLIFrameElement) {
      onIframeLoad(this.mediaElement, (iframe) => {
        const width = iframe.getAttribute('width')
        const height = iframe.getAttribute('height')
        if (width && height && !width.endsWith('%') && !height.endsWith('%')) {
          this.setMaxSize(Number.parseInt(width), Number.parseInt(height))
        }
      })
    }
    this.hideContent()
    this.showPlaceholder()
  }

  setMaxSize(width: number | null, height: number | null) {
    if (!this.element) {
      return
    }
    this.element.style.aspectRatio = `${width} / ${height}`
  }

  onClick(event: Event) {
    const target = event.target as HTMLElement
    if (target.tagName === 'A' || target.closest('a')) {
      return
    }

    if (!this.wasClicked) {
      const consentRequired = this.element?.dataset.consentRequired

      if (consentRequired && !this.hasConsent(consentRequired)) {
        this.setConsent(consentRequired)
      }

      this.hidePlaceholder()
      this.showContent()
      this.setUrl(this.mediaUrl)
      this.element?.dispatchEvent(new CustomEvent('media-defer:replaced'))
      this.wasClicked = true
    }
  }

  setUrl(url: string) {
    this.mediaElement?.setAttribute('src', url)
  }

  hidePlaceholder() {
    toggleHidden(this.placeholderElement, true)
  }

  showPlaceholder() {
    toggleHidden(this.placeholderElement, false)
  }

  showContent() {
    toggleHidden(this.contentElement, false)
    this.element?.classList.toggle('show', true)
  }

  hideContent() {
    toggleHidden(this.contentElement, true)
    this.element?.classList.toggle('show', false)
  }

  private get placeholderElement() {
    return this.element?.parentElement?.querySelector<HTMLElement>(
      '.media-defer__placeholder'
    )
  }

  private get contentElement() {
    return this.element?.parentElement?.querySelector<HTMLElement>(
      '.media-defer__content'
    )
  }

  private get mediaElement() {
    const selector = this.element?.dataset.deferTarget
    return selector ? this.element?.querySelector<HTMLElement>(selector) : null
  }

  private get mediaUrl() {
    return this.element?.dataset.deferUrl || ''
  }

  private hasConsent(consentType: string): boolean {
    if (typeof window.cookiehub !== 'undefined') {
      return window.cookiehub.hasConsented(consentType)
    }
    return false
  }

  private setConsent(consentType: string): void {
    if (typeof window.cookiehub !== 'undefined') {
      window.cookiehub.allow(consentType)
      setTimeout(() => {
        window.cookiehub.closeDialog()
      }, 0)
    }
  }
}

for (const elem of document.querySelectorAll<HTMLElement>('.media-defer')) {
  const instance = new MediaDefer(elem)
  ;(
    elem as HTMLElement & { mediaDeferInstance?: MediaDefer }
  ).mediaDeferInstance = instance
}
// utility functions

function toggleHidden(element: HTMLElement | null | undefined, state: boolean) {
  if (!element) {
    return
  }
  element.style.display = state ? 'none' : 'block'
}
